import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as C } from "./interface.js";
import T from "./TableParts/Body.js";
import E from "./TableParts/Header.js";
import { formatLength as h } from "../../_utils/css/format-length.js";
import { defineComponent as I, inject as B, computed as z, watchEffect as L, h as d } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as a } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const D = I({
  name: "MainTable",
  setup() {
    const {
      mergedClsPrefixRef: l,
      rightFixedColumnsRef: o,
      leftFixedColumnsRef: n,
      bodyWidthRef: i,
      maxHeightRef: u,
      minHeightRef: v,
      flexHeightRef: R,
      virtualScrollHeaderRef: b,
      syncScrollState: g
    } = B(C), c = a(null), r = a(null), m = a(null), s = a(!(n.value.length || o.value.length)), y = z(() => ({
      maxHeight: h(u.value),
      minHeight: h(v.value)
    }));
    function x(e) {
      i.value = e.contentRect.width, g(), s.value || (s.value = !0);
    }
    function H() {
      var e;
      const {
        value: t
      } = c;
      return t ? b.value ? ((e = t.virtualListRef) === null || e === void 0 ? void 0 : e.listElRef) || null : t.$el : null;
    }
    function p() {
      const {
        value: e
      } = r;
      return e ? e.getScrollContainer() : null;
    }
    const S = {
      getBodyElement: p,
      getHeaderElement: H,
      scrollTo(e, t) {
        var f;
        (f = r.value) === null || f === void 0 || f.scrollTo(e, t);
      }
    };
    return L(() => {
      const {
        value: e
      } = m;
      if (!e)
        return;
      const t = `${l.value}-data-table-base-table--transition-disabled`;
      s.value ? setTimeout(() => {
        e.classList.remove(t);
      }, 0) : e.classList.add(t);
    }), Object.assign({
      maxHeight: u,
      mergedClsPrefix: l,
      selfElRef: m,
      headerInstRef: c,
      bodyInstRef: r,
      bodyStyle: y,
      flexHeight: R,
      handleBodyResize: x
    }, S);
  },
  render() {
    const {
      mergedClsPrefix: l,
      maxHeight: o,
      flexHeight: n
    } = this, i = o === void 0 && !n;
    return d("div", {
      class: `${l}-data-table-base-table`,
      ref: "selfElRef"
    }, i ? null : d(E, {
      ref: "headerInstRef"
    }), d(T, {
      ref: "bodyInstRef",
      bodyStyle: this.bodyStyle,
      showHeader: i,
      flexHeight: n,
      onResize: this.handleBodyResize
    }));
  }
});
export {
  D as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/MainTable.js
// module id = 1651
// module chunks = 67